import React from 'react';
import BuildIcon from '@mui/icons-material/Build';

// Helper function to create orders-specific columns
export const createOrdersColumns = (onPreviewClick) => [
    { 
        field: 'preview', 
        headerName: 'Preview', 
        width: 80, 
        headerAlign: 'center',
        align: 'center',
        sortable: false,
        filterable: false,
        renderCell: (params) => (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <button 
                    style={{
                        padding: '8px',
                        backgroundColor: '#007bff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '50%',
                        cursor: 'pointer',
                        fontSize: '14px',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        transition: 'background-color 0.3s ease',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                    onClick={() => onPreviewClick(params.row.id)}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
                >
                    <BuildIcon 
                        style={{
                            fontSize: '20px', 
                            color: '#fff', 
                            pointerEvents: 'none',
                            transition: 'none',
                        }} 
                    />
                </button>
            </div>
        ),
    },
    { field: 'fullName', headerName: 'Full Name', width: 130, headerAlign: 'center', align: 'center' },
    { field: 'address', headerName: 'Street', width: 130, headerAlign: 'center', align: 'center' },
    { field: 'city', headerName: 'City', width: 130, headerAlign: 'center', align: 'center' },
    { field: 'email', headerName: 'Email', width: 140, headerAlign: 'center', align: 'center' },
    { field: 'phone', headerName: 'Phone', width: 110, headerAlign: 'center', align: 'center' },
    { field: 'paymentMethod', headerName: 'Payment', width: 100, headerAlign: 'center', align: 'center' },
    { field: 'originalPrice', headerName: 'Original Price', type: 'number', width: 110, headerAlign: 'center', align: 'center' },
    { field: 'finalPrice', headerName: 'Final Price', type: 'number', width: 100, headerAlign: 'center', align: 'center' },
    { field: 'notes', headerName: 'Notes', width: 120, headerAlign: 'center', align: 'center' },
    { 
        field: 'dateTime', 
        headerName: 'Order Time', 
        width: 120, 
        headerAlign: 'center', 
        align: 'center',
    },
];

// Helper function to create basic columns for simple data
export const createBasicColumns = (fields) => {
    return fields.map(field => ({
        field: field.field,
        headerName: field.headerName || field.field,
        width: field.width || 150,
        headerAlign: field.headerAlign || 'center',
        align: field.align || 'center',
        type: field.type || 'string',
        ...field.extraProps
    }));
};

// Helper function to create action column
export const createActionColumn = (headerName = 'Actions', width = 120, actions = []) => ({
    field: 'actions',
    headerName,
    width,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    filterable: false,
    renderCell: (params) => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', height: '100%' }}>
            {actions.map((action, index) => (
                <button
                    key={index}
                    style={{
                        padding: '6px 12px',
                        backgroundColor: action.color || '#007bff',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        ...action.style
                    }}
                    onClick={() => action.onClick(params.row)}
                    title={action.tooltip}
                >
                    {action.icon || action.label}
                </button>
            ))}
        </div>
    ),
});
